export const PATHS = {
  HOME: '/',
  CHAT: '/chat',
  SIGN_IN: '/sign-in',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  VERIFY_OTP: '/verify-otp',
  PROFILE: '/profile',
  MY_TWIN: '/my-twin',
  TWINS: '/twins',
  GOOGLE: '/oauth/google',
  BUY_POINTS: '/buy-points',
  SUBSCRIBED_TWINS: '/subscribed-twins',
  EXPLORE_TWINS: '/explore-twins',
  FEEDBACK: '/feedback',
  TWIN_STUDIO: '/twin-studio',
  TWIN_STUDIO_COLLECTION: '/twin-studio/collection',
  VIDEO_PLAYBACK: '/watch',
  UPDATE_TWIN: '/my-twin/update',
  MANAGE_TWIN_PLANS: '/my-twin/plan',
  CHECKOUT: '/checkout',
  TWIN_LANDING: '/twin-landing',
  PACKAGES: '/my-twin/packages',
  UPGRADE_TWIN: '/twin-landing#pricing',
  TWIN_STUDIO_LANDING: '/twin-studio-landing',
  MEDICAL: '/medical-profile',
  MEDICAL_HISTORY: '/medical-history',
  Patient_Details:'/patient-details'
};
